/* ⚠️ MG 5–6 Sep 2026 — THIS FILE CARRIES MADE GOOD CUSTOMISATIONS.
   >>> Do NOT take the stock/default version wholesale in an update conflict. Diff it first. <<<

   mg-menu.js — THE MEGA-MENU CONTROLLER ("Option C"), on V16 since 6 Sep 2026.
   Until the Phase 3 tidy (6 Sep, later the same day) this file was served as mg-mm-new-item-close.js;
   that name was historical and the asset is retired. Loaded by one <script defer> tag in
   layout/theme.liquid after mg-grid-reveal.js. The pre-controller contents of the old file (fixes 2–12,
   the safe triangle and the 5 Sep gap bridge) are archived in _source-archive/2026-09-06-mm-controller/.

   ================================= WHAT THIS IS =================================
   ONE owner of mega-menu state. Before this file, five actors wrote the same classes (utilities.js
   .hover(), its .lowopacity binding, z__jsHeader's four trailing blocks, mg-tweaks.css, and the old
   version of this file) and every fix was a referee between them. Now:

     ⋄ utilities.js's .hover() on the dropdown items and its .lowopacity mouseenter/mouseleave are
       UNBOUND at init (surgically, by handler source — nothing else on those elements is touched).
     ⋄ z__jsHeader's four trailing MG blocks (27–28 Jul gap fix, warmed, pre-warm, mg-mm-holding) are
       unbound the same way. The blocks are still in that file for now; deleting them is a Phase 3 job.
       z__jsHeader's tier-1 `mouseover` column switch is KEPT — it is what the safe triangle guards.
     ⋄ A region test on pointermove replaces every mouseleave-then-repair pattern: the pointer is
       either over a dropdown item, a plain item (New), the open panel, or outside — and each of
       those has exactly one meaning. The 2px band under the items (header padding + border) is
       closed by giving each dropdown item a 2px reach (CSS below), so there is no no-man's land.
     ⋄ The panel and content choreography is owned by the CSS injected below (id mg-menu-css), keyed
       ONLY to classes this file sets: .mg-open on the item, .mg-in for the contents, .mg-hide for a
       swapped-out panel. The mg-tweaks.css / mg-p23.css / mg-megamenu-line.css panel rules still
       exist but are outranked by specificity; they were keyed to :hover and to warmed states that
       no longer happen.
     ⋄ The header-colour, logo, frost and grey-line systems are untouched: this file still emits the
       classes they read — .active on the item, body.dropdown-visible, html.scroll-locked,
       .lowopacity on the siblings, body.mg-mm-holding at the top of the page, and the tier-1
       column's .active.

   ================================= BEHAVIOUR (Will, 5 Sep 2026) =================================
     1. Onto "New" (a plain item) → close at once, no grace.
     2. Shop ↔ Collections → swap: contents cross-fade, panel stays; a height difference animates.
     3. One clock for all three menus. Contents sweep in top-to-bottom; the old layout_1 column
        stagger and FIX 4b's separate Makers timing are retired.
     4. Contents fade OUT before the panel slides up.
     5. Open grace (only when nothing is open) stops a pass across the header from flashing a menu.
        Close grace forgives a wobble at the panel edge. Sideways off an item into empty header
        closes (with the grace).
     6. Keyboard: Enter on Shop/Collections/Makers opens; Enter again follows the link; ↓ opens and
        moves into the panel; Esc closes and returns focus; Tab past the last link or Shift+Tab before
        the first closes; focus leaving the header closes. Focus alone never opens (decision 3).
     7. Tier-1 headings inside Shop: hover switches instantly except across the safe triangle
        (kept from 5 Sep); focusing a heading switches too, so the keyboard can reach submenus.

   TOKENS — from the tuner (mg-menu-tuner-2026-09-05.html), preset "Considered", Will 5 Sep:
     open 650ms cubic-bezier(.22,1,.36,1) · close 475ms cubic-bezier(.45,0,.2,1) · open grace 90 ·
     close grace 120 · contents in from 120ms over 260ms · out 150ms · swap 200ms · height 300ms.
     They are written as --mg-mm-* custom properties on :root, so retuning is a number here.

   THREE LAWS (still true): (A) a transition needs a painted start frame — prime across two rAFs;
   (B) transitionDuration lies, check getAnimations(); (C) synthetic mouseover does not set :hover —
   test with real input. The harness: _source-archive/2026-09-06-mm-controller/harness/ (node suite.mjs).

   To revert: upload the BEFORE file from the archive over this one. Nothing else changed. */
(function () {
  'use strict';
  if (window.__mgMenuBound) return;
  window.__mgMenuBound = 1;

  var T = {
    open: 650, close: 475,
    openEase: 'cubic-bezier(.22,1,.36,1)', closeEase: 'cubic-bezier(.45,0,.2,1)',
    openGrace: 90, closeGrace: 120,
    inStart: 120, inSweep: 260, out: 150, swap: 200, height: 300
  };
  var TRI_HOLD_MS = 300, ANCHOR_MS = 40;   /* safe triangle, unchanged from 5 Sep */
  var HOLDING_MS = 1700;                    /* body.mg-mm-holding lifetime after a close, as before */

  var ITEM = '.navbar-item.has-dropdown--horizontal';
  var PANEL = '.navbar-dropdown.is-horizontal';
  /* x2 / x3 class repeats lift specificity over mg-tweaks (0,5,1), mg-p23 (0,4,0) and
     mg-megamenu-line (0,5,1), all of which use !important. */
  var I2 = ITEM + '.has-dropdown--horizontal';
  var I3 = I2 + '.has-dropdown--horizontal';

  function css() {
    var t = [
      ':root{--mg-mm-open:' + T.open + 'ms;--mg-mm-close:' + T.close + 'ms;--mg-mm-open-ease:' + T.openEase + ';--mg-mm-close-ease:' + T.closeEase + ';' +
        '--mg-mm-in-start:' + T.inStart + 'ms;--mg-mm-in-sweep:' + T.inSweep + 'ms;--mg-mm-out:' + T.out + 'ms;--mg-mm-swap:' + T.swap + 'ms;--mg-mm-height:' + T.height + 'ms;' +
        /* the header colour / logo / border hold rules in mg-tweaks read this one token */
        '--mg-mm-headerhold:calc(var(--mg-mm-out) + var(--mg-mm-close));--mg-mm-closedelay:0ms;}',
      /* decision 4 — the 2px reach: the item box meets the panel, so no pointer position belongs to nobody */
      '.header__menu-items > ' + ITEM + '{padding-bottom:2px!important;margin-bottom:-2px!important;}',
      /* panel: closed */
      I3 + ' ' + PANEL + '{clip-path:inset(0 0 100% 0)!important;visibility:hidden!important;opacity:1!important;pointer-events:none!important;' +
        'background-position:0 -1px!important;' +
        'transition:clip-path var(--mg-mm-close) var(--mg-mm-close-ease),background-position var(--mg-mm-close) var(--mg-mm-close-ease),visibility 0s linear var(--mg-mm-close)!important;}',
      /* panel: open */
      I3 + '.mg-open ' + PANEL + '{clip-path:inset(0 0 0 0)!important;visibility:visible!important;pointer-events:auto!important;z-index:21!important;' +
        'background-position:0 100%!important;' +
        'transition:clip-path var(--mg-mm-open) var(--mg-mm-open-ease),background-position var(--mg-mm-open) var(--mg-mm-open-ease),visibility 0s!important;}',
      /* swap: incoming panel appears already open (no slide); a height difference animates via --mg-clip */
      I3 + '.mg-open.mg-snap ' + PANEL + '{transition:clip-path var(--mg-mm-height) ease,background-position 0s,visibility 0s!important;clip-path:var(--mg-clip,inset(0 0 0 0))!important;}',
      /* the first frame of a swap: no transition at all, so the incoming panel is simply there */
      I3 + '.mg-open.mg-snap.mg-snap0 ' + PANEL + '{transition:none!important;}',
      /* swap: outgoing panel, hidden the instant its contents have faded */
      I3 + '.mg-hide ' + PANEL + '{visibility:hidden!important;transition:none!important;}',
      /* contents: the sweep targets */
      I3 + ' ' + PANEL + ' .section .horizontal-dropdown__column > a,' +
      I3 + ' ' + PANEL + ' .section .mm-l2-intro > *,' +
      I3 + ' ' + PANEL + ' .mega-menu-images,' +
      I3 + '.megamenu-layout_2 ' + PANEL + ' .section .horizontal-dropdown__column > .navbar-submenu > li{' +
        'opacity:0!important;transform:translateY(4px)!important;' +
        'transition:opacity var(--mg-mm-out) ease,transform var(--mg-mm-out) ease,color .3s ease-in-out!important;transition-delay:0s!important;}',
      I3 + '.mg-in ' + PANEL + ' .section .horizontal-dropdown__column > a,' +
      I3 + '.mg-in ' + PANEL + ' .section .mm-l2-intro > *,' +
      I3 + '.mg-in ' + PANEL + ' .mega-menu-images,' +
      I3 + '.megamenu-layout_2.mg-in ' + PANEL + ' .section .horizontal-dropdown__column > .navbar-submenu > li{' +
        'opacity:1!important;transform:none!important;' +
        'transition:opacity var(--mg-mm-in-sweep) ease-out var(--mg-d,0ms),transform var(--mg-mm-in-sweep) ease-out var(--mg-d,0ms),color .3s ease-in-out!important;}',
      /* swap-in: contents cross-fade on the swap clock, no sweep delay */
      I3 + '.mg-in.mg-snap ' + PANEL + ' .section .horizontal-dropdown__column > a,' +
      I3 + '.mg-in.mg-snap ' + PANEL + ' .section .mm-l2-intro > *,' +
      I3 + '.mg-in.mg-snap ' + PANEL + ' .mega-menu-images,' +
      I3 + '.megamenu-layout_2.mg-in.mg-snap ' + PANEL + ' .section .horizontal-dropdown__column > .navbar-submenu > li{' +
        'transition:opacity var(--mg-mm-swap) ease,transform var(--mg-mm-swap) ease,color .3s ease-in-out!important;transition-delay:0s!important;}',
      /* Makers names follow the panel, never outrun it (FIX 8, kept) */
      I3 + '.megamenu-layout_2 ' + PANEL + ' .section .horizontal-dropdown__column > .navbar-submenu{visibility:inherit!important;opacity:1!important;}',
      I3 + '.megamenu-layout_2 ' + PANEL + ' .section .horizontal-dropdown__column > .navbar-submenu > li{visibility:inherit!important;}',
      /* the mega-menu images inside a panel: stacked crossfade is mg-tweaks' job; only the container fades here */
      /* tier-1 heading colour follows .active, not :hover, while the triangle holds a switch back (5 Sep) */
      '.megamenu-layout_1:not(.lowopacity) ' + PANEL + ' .section .horizontal-dropdown__column:not(.active):hover > a.menu__heading,' +
      '.megamenu-layout_1:not(.lowopacity) ' + PANEL + ' .section .horizontal-dropdown__column:not(.active):hover > a.no-sub-link{color:var(--mg-mm-rest)!important;}',
      /* keyboard: a focused heading reads as active (colour) even before the column switch lands */
      '.megamenu-layout_1:not(.lowopacity) ' + PANEL + ' .section .horizontal-dropdown__column > a.menu__heading:focus-visible{color:var(--mg-mm-hot)!important;outline:none;text-decoration:underline!important;text-underline-offset:3px;}',
      '.header__menu-items .header__link:focus-visible{outline:none;text-decoration:underline;text-underline-offset:4px;}',
      '@media (prefers-reduced-motion:reduce){:root{--mg-mm-open:0ms;--mg-mm-close:0ms;--mg-mm-in-sweep:0ms;--mg-mm-in-start:0ms;--mg-mm-out:0ms;--mg-mm-swap:0ms;--mg-mm-height:0ms;}}'
    ];
    return t.join('');
  }
  function injectCSS() {
    if (document.getElementById('mg-menu-css')) return;
    var s = document.createElement('style'); s.id = 'mg-menu-css'; s.textContent = css();
    document.head.appendChild(s);
  }

  /* ------------------------------------------------------------------ unbinding the old actors */
  function unbindTheme($) {
    /* ⚠️ jQuery files mouseenter/mouseleave under 'mouseover'/'mouseout' (special events) with the
       original name in h.origType — so walk EVERY stored type and unbind by origType. The first
       deploy looked for 'mouseenter' keys, found none, and left every theme handler bound (6 Sep). */
    function strip(el, needle) {
      var ev = $._data(el, 'events'); if (!ev) return;
      Object.keys(ev).forEach(function (type) {
        var list = ev[type]; if (!list) return;
        list.slice().forEach(function (h) {
          var src = (h.handler && h.handler.toString()) || '';
          if (needle.test(src)) $(el).off(h.origType || type, h.selector || undefined, h.handler);
        });
      });
    }
    /* utilities.js: .hover() on the dropdown items (adds .active / dropdown-visible / scroll-locked) */
    document.querySelectorAll(ITEM).forEach(function (li) {
      strip(li, /dropdown-visible|scroll-locked/);
    });
    /* utilities.js: .lowopacity on every header item */
    document.querySelectorAll('.navbar-item.header__item').forEach(function (li) {
      strip(li, /lowopacity/);
    });
    /* z__jsHeader.js: the four trailing MG blocks, delegated on the row */
    var row = document.querySelector('.header__menu-items');
    if (row) strip(row, /dropdown-visible|mg-warmed|mg-mm-holding|scroll-locked/);
  }

  /* ------------------------------------------------------------------ the controller */
  function init() {
    injectCSS();
    if (typeof window.jQuery === 'undefined') return;
    var $ = window.jQuery;
    var row = document.querySelector('.header__menu-items'); if (!row) return;
    if (row.dataset.mgMenu) return; row.dataset.mgMenu = '1';
    var header = document.getElementById('header') || document.querySelector('.header-section');
    var items = Array.prototype.slice.call(row.querySelectorAll(ITEM));
    if (!items.length) return;
    unbindTheme($);
    window.addEventListener('load', function () { unbindTheme($); });   /* z__jsHeader binds late on some templates */

    var state = 'closed', cur = null;
    var openT = null, closeT = null, outT = null, doneT = null, holdT = null, inT = null;
    var lastZone = 'out';

    function panelOf(li) { return li.querySelector(PANEL); }
    function linkOf(li) { return li.querySelector('.header__link'); }
    function isSticky() { var w = document.querySelector('.header-sticky-wrapper'); return !!(w && w.classList.contains('is-sticky')); }
    function clear(t) { if (t) clearTimeout(t); return null; }

    function ariaInit() {
      items.forEach(function (li, i) {
        var a = linkOf(li), p = panelOf(li); if (!a || !p) return;
        if (!p.id) p.id = 'mg-menu-panel-' + i;
        a.setAttribute('aria-haspopup', 'true'); a.setAttribute('aria-expanded', 'false'); a.setAttribute('aria-controls', p.id);
        p.setAttribute('role', 'region'); p.setAttribute('aria-label', (a.textContent || 'Menu').trim() + ' menu');
      });
      var logo = document.querySelector('a.header__logo');
      if (logo && !logo.getAttribute('aria-label') && !logo.textContent.trim()) logo.setAttribute('aria-label', 'Made Good – home');
      var search = document.querySelector('[data-show-search-trigger]');
      if (search && !search.getAttribute('role')) search.setAttribute('role', 'button');
    }

    function dim(li) {
      row.querySelectorAll('.navbar-item.header__item').forEach(function (el) { el.classList.toggle('lowopacity', !!li && el !== li); });
    }
    function expanded(li) { items.forEach(function (el) { linkOf(el).setAttribute('aria-expanded', String(el === li)); }); }
    function stagger(li) {
      var p = panelOf(li); if (!p) return;
      var box = p.getBoundingClientRect(), H = box.height || 1;
      var els = p.querySelectorAll('.section .horizontal-dropdown__column > a,.section .mm-l2-intro > *,.mega-menu-images,.section .horizontal-dropdown__column > .navbar-submenu > li');
      for (var i = 0; i < els.length; i++) {
        var f = (els[i].getBoundingClientRect().top - box.top) / H; if (f < 0) f = 0; else if (f > 1) f = 1;
        els[i].style.setProperty('--mg-d', Math.round(T.inStart + f * T.inSweep) + 'ms');
      }
    }
    function holding(on) {
      holdT = clear(holdT);
      if (on) { if (!isSticky()) document.body.classList.add('mg-mm-holding'); }
      else holdT = setTimeout(function () { document.body.classList.remove('mg-mm-holding'); }, HOLDING_MS);
    }
    function warmImages() { if (typeof window.__mgWarmMegaMenuImages === 'function') window.__mgWarmMegaMenuImages(); }

    function open(li) {
      openT = clear(openT); closeT = clear(closeT); outT = clear(outT); doneT = clear(doneT); inT = clear(inT);
      if (cur && cur !== li && state !== 'closed') { swap(li); return; }
      cur = li; state = 'opening';
      warmImages();
      items.forEach(function (el) { if (el !== li) { el.classList.remove('active', 'mg-open', 'mg-in', 'mg-snap', 'mg-snap0'); } el.classList.remove('mg-hide'); });
      li.classList.remove('mg-snap', 'mg-snap0'); li.style.removeProperty('--mg-clip');
      li.classList.add('active');
      document.body.classList.add('dropdown-visible');
      document.documentElement.classList.add('scroll-locked');
      dim(li); expanded(li); holding(true);
      stagger(li);
      li.classList.add('mg-open');
      /* law (A): a painted frame before the contents start, so their transition has a start value */
      var armIn = function () { if (cur === li && state !== 'closing') li.classList.add('mg-in'); };
      requestAnimationFrame(function () { requestAnimationFrame(armIn); });
      inT = setTimeout(armIn, 80);   /* rAF does not tick in a hidden tab; never leave a panel open and blank */
      doneT = setTimeout(function () { if (cur === li) state = 'open'; }, T.open);
    }
    function swap(to) {
      var from = cur; cur = to; state = 'opening';
      var fromH = panelOf(from).getBoundingClientRect().height, toH = panelOf(to).getBoundingClientRect().height;
      /* outgoing: contents out, then hidden */
      from.classList.remove('mg-in', 'active', 'mg-snap0'); from.classList.add('mg-snap');
      if (toH < fromH) { from.style.setProperty('--mg-clip', 'inset(0 0 ' + Math.round(fromH - toH) + 'px 0)'); }
      outT = setTimeout(function () { from.classList.add('mg-hide'); from.classList.remove('mg-open', 'mg-snap'); from.style.removeProperty('--mg-clip'); }, Math.max(T.out, toH < fromH ? T.height : 0));
      /* incoming: already open, contents cross-fade; if taller, its lower edge grows from the outgoing height */
      to.classList.remove('mg-hide');
      if (toH > fromH) { to.style.setProperty('--mg-clip', 'inset(0 0 ' + Math.round(toH - fromH) + 'px 0)'); }
      to.classList.add('mg-snap', 'mg-snap0', 'mg-open', 'active');
      dim(to); expanded(to); stagger(to);
      var armSwap = function () {
        if (cur !== to || to.classList.contains('mg-in')) return;
        to.classList.remove('mg-snap0');
        to.style.setProperty('--mg-clip', 'inset(0 0 0 0)');
        to.classList.add('mg-in');
        doneT = setTimeout(function () { if (cur === to) { to.classList.remove('mg-snap', 'mg-snap0'); to.style.removeProperty('--mg-clip'); state = 'open'; } }, Math.max(T.swap, T.height) + 20);
      };
      requestAnimationFrame(function () { requestAnimationFrame(armSwap); });
      inT = setTimeout(armSwap, 80);
    }
    function close() {
      openT = clear(openT); closeT = clear(closeT); outT = clear(outT); doneT = clear(doneT);
      if (state === 'closed' || state === 'closing') return;
      var li = cur; state = 'closing';
      li.classList.remove('mg-in', 'mg-snap', 'mg-snap0'); li.style.removeProperty('--mg-clip');
      expanded(null);
      outT = setTimeout(function () {
        li.classList.remove('mg-open', 'active');
        document.body.classList.remove('dropdown-visible');
        document.documentElement.classList.remove('scroll-locked');
        li.querySelectorAll('.horizontal-dropdown__column.active').forEach(function (c) { c.classList.remove('active'); });
        dim(null); holding(false);
        doneT = setTimeout(function () { if (state === 'closing') { state = 'closed'; cur = null; items.forEach(function (el) { el.classList.remove('mg-hide'); }); } }, T.close + 20);
      }, T.out);
    }
    function requestOpen(li) {
      closeT = clear(closeT);
      if (state === 'closing') { /* re-entry mid-close: contents may still be fading — reopen at once */
        outT = clear(outT); doneT = clear(doneT); state = 'open';
        if (cur === li) { cur = null; }
        open(li); return;
      }
      if (state !== 'closed') { if (cur !== li) open(li); return; }
      openT = clear(openT);
      openT = setTimeout(function () { open(li); }, T.openGrace);
    }
    function requestClose(immediate) {
      openT = clear(openT);
      if (state === 'closed' || state === 'closing') return;
      closeT = clear(closeT);
      if (immediate) close(); else closeT = setTimeout(close, T.closeGrace);
    }

    /* region test — the one and only meaning of "where is the pointer" */
    function zone(x, y) {
      var el = document.elementFromPoint(x, y); if (!el) return 'out';
      /* ⚠️ the header items are <div class="navbar-item">, not <li> — the first harness had <li> and
         `> li` matched nothing on the real site, so hover never registered (6 Sep, v4). */
      var li = el.closest ? el.closest('.header__menu-items > .navbar-item') : null;
      if (li) return li.matches(ITEM) ? 'item:' + items.indexOf(li) : 'plain';
      if (cur && panelOf(cur).contains(el)) return 'panel';
      return 'out';
    }
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var z = zone(e.clientX, e.clientY);
      /* the zone is compared to the last one so a resting pointer costs nothing — but a menu that was
         closed by something other than the pointer (Escape, focus-out, a click, a hidden tab) leaves
         the pointer parked on an item with nothing open, and the next movement must still count. */
      if (z === lastZone && !(z.indexOf('item:') === 0 && (state === 'closed' || state === 'closing') && !openT)) return;
      lastZone = z;
      if (z.indexOf('item:') === 0) requestOpen(items[+z.slice(5)]);
      else if (z === 'plain') requestClose(true);
      else if (z === 'panel') { closeT = clear(closeT); openT = clear(openT); }
      else requestClose(false);
    }, { passive: true });
    document.documentElement.addEventListener('mouseleave', function () { lastZone = 'out'; requestClose(false); });
    document.addEventListener('pointerdown', function (e) {
      if (state === 'closed') return;
      if (!header || !header.contains(e.target)) requestClose(true);
    }, { passive: true });

    /* keyboard */
    function firstLink(li) { return panelOf(li).querySelector('a[href], button, [tabindex]:not([tabindex="-1"])'); }
    function panelLinks(li) { return Array.prototype.filter.call(panelOf(li).querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])'), function (a) { return a.offsetParent !== null || getComputedStyle(a).position === 'fixed'; }); }
    items.forEach(function (li) {
      var a = linkOf(li);
      a.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          if (state !== 'closed' && state !== 'closing' && cur === li) return;   /* second Enter: follow the link */
          e.preventDefault(); open(li);
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (state === 'closed' || state === 'closing' || cur !== li) open(li);
          var f = firstLink(li); if (f) setTimeout(function () { f.focus(); }, 0);
        }
      });
      /* tier-1 headings: focus switches the column like hover does (keyboard reaches the submenus) */
      panelOf(li).addEventListener('focusin', function (e) {
        var head = e.target.closest ? e.target.closest('.navbar-item.menu__heading, .navbar-item.no-sub-link') : null;
        if (!head || !li.classList.contains('megamenu-layout_1')) return;
        var col = head.parentNode; if (!col || !col.classList.contains('horizontal-dropdown__column')) return;
        Array.prototype.forEach.call(col.parentNode.children, function (c) { c.classList.toggle('active', c === col); });
        var handle = head.getAttribute('data-linkhandle');
        var img = handle ? li.querySelector('.main-' + handle) : null;
        if (img) { var wrap = img.closest('.mega-menu-images'); if (wrap) Array.prototype.forEach.call(wrap.children, function (c) { c.classList.toggle('active', c === img.parentNode); }); }
      });
      panelOf(li).addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var links = panelLinks(li); if (!links.length) return;
        if (!e.shiftKey && document.activeElement === links[links.length - 1]) close();
        if (e.shiftKey && document.activeElement === links[0]) { e.preventDefault(); close(); a.focus(); }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state !== 'closed' && state !== 'closing' && cur) { var a = linkOf(cur); close(); if (a) a.focus(); }
    });
    document.addEventListener('focusin', function (e) {
      if (state === 'closed' || state === 'closing') return;
      if (header && !header.contains(e.target)) close();
    });

    /* ------------------------------------------------ safe triangle (5 Sep), unchanged in substance */
    var trail = [], triUntil = 0, suppressed = null, triTimer = null, bypass = false;
    function anchor() { var now = Date.now(); for (var i = trail.length - 1; i >= 0; i--) if (now - trail[i].t >= ANCHOR_MS) return trail[i]; return trail.length ? trail[0] : null; }
    function side(ax, ay, bx, by, cx, cy) { return (bx - ax) * (cy - ay) - (by - ay) * (cx - ax); }
    function inTri(x, y, ax, ay, bx, by, cx, cy) { var d1 = side(ax, ay, bx, by, x, y), d2 = side(bx, by, cx, cy, x, y), d3 = side(cx, cy, ax, ay, x, y); return !(((d1 < 0) || (d2 < 0) || (d3 < 0)) && ((d1 > 0) || (d2 > 0) || (d3 > 0))); }
    function activeSubRect(head) {
      var li = head.closest(ITEM); if (!li || !li.classList.contains('megamenu-layout_1')) return null;
      var col = li.querySelector('.horizontal-dropdown__column.active'); if (!col) return null;
      var sub = col.querySelector('.navbar-submenu'); if (!sub) return null;
      var r = sub.getBoundingClientRect(); return (r.width > 0 && r.height > 0) ? r : null;
    }
    function shouldSuppress(head, x, y) {
      if (Date.now() > triUntil) return false;
      var col = head.parentNode; if (!col || !col.classList || !col.classList.contains('horizontal-dropdown__column') || col.classList.contains('active')) return false;
      var r = activeSubRect(head); if (!r || x >= r.left) return false;
      var a = anchor(); if (!a) return false;
      return inTri(x, y, a.x, a.y, r.left, r.top, r.left, r.bottom);
    }
    function armRelease() { if (triTimer) clearTimeout(triTimer); triTimer = setTimeout(function () { triTimer = null; if (suppressed && Date.now() > triUntil) release(); else if (suppressed) armRelease(); }, Math.max(16, triUntil - Date.now() + 16)); }
    function release() {
      var h = suppressed; suppressed = null; if (triTimer) { clearTimeout(triTimer); triTimer = null; }
      if (!h || !document.contains(h)) return;
      var last = trail.length ? trail[trail.length - 1] : null; bypass = true;
      try { h.dispatchEvent(new MouseEvent('mouseover', { bubbles: true, cancelable: true, clientX: last ? last.x : 0, clientY: last ? last.y : 0 })); } catch (err) {}
      bypass = false;
    }
    document.addEventListener('mousemove', function (ev) {
      if (state === 'closed') { if (trail.length) trail.length = 0; return; }
      var a = anchor(); trail.push({ x: ev.clientX, y: ev.clientY, t: Date.now() }); while (trail.length > 16) trail.shift();
      if (a && ev.clientX - a.x > 2) triUntil = Date.now() + TRI_HOLD_MS;
      if (suppressed && Date.now() > triUntil) release();
    }, { passive: true });
    document.addEventListener('mouseover', function (ev) {
      if (bypass || state === 'closed') return;
      var t = ev.target, head = (t && t.closest) ? t.closest('.navbar-item.menu__heading, .navbar-item.no-sub-link') : null; if (!head) return;
      if (shouldSuppress(head, ev.clientX, ev.clientY)) { suppressed = head; armRelease(); ev.stopPropagation(); return; }
      suppressed = null; if (triTimer) { clearTimeout(triTimer); triTimer = null; }
      var col = head.parentNode; if (col && col.classList && col.classList.contains('horizontal-dropdown__column')) triUntil = Date.now() + TRI_HOLD_MS;
    }, true);
    document.addEventListener('mouseout', function (ev) { if (suppressed && ev.target === suppressed) { suppressed = null; if (triTimer) { clearTimeout(triTimer); triTimer = null; } } }, true);

    ariaInit();
    window.__mgMenu = { open: function (i) { open(items[i]); }, close: close, state: function () { return { state: state, cur: cur ? items.indexOf(cur) : -1 }; }, T: T };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
